module.exports = __webpack_public_path__ + "img/sdg_en_(2).9a46f57a.png";